import { getResubscribePackagesList, resubscribePackage } from "./ResubscribeActions";
import { createSlice } from "@reduxjs/toolkit";

interface ResubscribeState {
  resubscribePackagesListLoading: boolean;
  resubscribePackagesListError: any | null;
  resubscribePackagesListData: any | null;

  resubscribePackageLoading: boolean;
  resubscribePackageError: any | null;
  resubscribePackageData: any | null;
}

const initialState: ResubscribeState = {
  resubscribePackagesListLoading: false,
  resubscribePackagesListError: null,
  resubscribePackagesListData: null,

  resubscribePackageLoading: false,
  resubscribePackageError: null,
  resubscribePackageData: null,
};

const resubscribeSlice = createSlice({
  name: "resubscribe",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getResubscribePackagesList.pending, (state) => {
      state.resubscribePackagesListLoading = true;
      state.resubscribePackagesListError = null;
      state.resubscribePackagesListData = null;
    });
    builder.addCase(getResubscribePackagesList.fulfilled, (state, action) => {
      state.resubscribePackagesListData = action.payload;
      state.resubscribePackagesListLoading = false;
      state.resubscribePackagesListError = null;
    });
    builder.addCase(getResubscribePackagesList.rejected, (state, action) => {
      state.resubscribePackagesListError = action.payload;
      state.resubscribePackagesListLoading = false;
      state.resubscribePackagesListData = null;
    });
    builder.addCase(resubscribePackage.pending, (state) => {
      state.resubscribePackageLoading = true;
      state.resubscribePackageError = null;
      state.resubscribePackageData = null;
    });
    builder.addCase(resubscribePackage.fulfilled, (state, action) => {
      state.resubscribePackageData = action.payload;
      state.resubscribePackageLoading = false;
      state.resubscribePackageError = null;
    });
    builder.addCase(resubscribePackage.rejected, (state, action) => {
      state.resubscribePackageError = action.payload;
      state.resubscribePackageLoading = false;
      state.resubscribePackageData = null;
    });
  },
});

const resubscribeReducer = resubscribeSlice.reducer;

export default resubscribeReducer;
